import { render } from "./HistoryModal.vue?vue&type=template&id=2502facd&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"

import "./HistoryModal.vue?vue&type=style&index=0&id=2502facd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2502facd"]])

export default __exports__